import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { logout } from '../session/logoutThunk';
import type { RootState } from '../store';

type MemberProfileSummaryState = Readonly<{
  byMemberId: Record<number, string>;
}>;

const initialState: MemberProfileSummaryState = { byMemberId: {} };

export const memberProfileSummarySlice = createSlice({
  name: 'memberProfileSummary',
  initialState,
  reducers: {
    setMemberProfileSummary: (
      state,
      action: PayloadAction<Readonly<{ memberId: number; summary: string }>>,
    ) => {
      state.byMemberId[action.payload.memberId] = action.payload.summary;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setMemberProfileSummary } = memberProfileSummarySlice.actions;

export const memberProfileSummaryReducer = memberProfileSummarySlice.reducer;

export const selectMemberProfileSummary =
  (memberId: number | undefined) =>
  (state: RootState): string | undefined =>
    memberId === undefined ? undefined : state.memberProfileSummary.byMemberId[memberId];
